import React from 'react'
import { useTranslation } from '@mc/i18n'
import {
  TrackClick,
  TrackingAttributes,
} from '../../../tracking/educatorTracking'

interface CoreSessionContinueProps {
  email: string
  onContinue: () => void
  onNotYou: () => void
  disabled?: boolean
}

export const CoreSessionContinue = ({
  email,
  onContinue,
  onNotYou,
  disabled = false,
}: CoreSessionContinueProps) => {
  const { t } = useTranslation()

  return (
    <TrackingAttributes location='email form'>
      <div className='flex flex-col gap-3 items-center w-full'>
        <TrackClick
          event='educatorClick'
          action='continue as signed in account'
        >
          <button
            type='button'
            onClick={onContinue}
            disabled={disabled}
            className='w-full h-12 px-4 bg-button-primary-default border-none font-sans font-semibold text-sm leading-none tracking-[0.14px] text-text-invert cursor-pointer transition-colors flex items-center justify-center hover:enabled:bg-button-primary-hover disabled:opacity-50 disabled:cursor-not-allowed'
          >
            <span className='truncate'>
              {t('emailEntry.continueAs', { email })}
            </span>
          </button>
        </TrackClick>
        <TrackClick event='educatorClick' action='not you'>
          <button
            type='button'
            onClick={onNotYou}
            disabled={disabled}
            className='bg-transparent border-none p-0 font-sans text-xs leading-none text-text-secondary underline cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed'
          >
            {t('emailEntry.notYou')}
          </button>
        </TrackClick>
      </div>
    </TrackingAttributes>
  )
}
